import { Tooltip } from "antd";
import classNames from "classnames";
import { CommonService } from "@Services/common-service";
import React from "react";
import "./LayoutHeader.scss";

export interface LayoutHeaderProps {
  /**Used to change style Component */
  className?: string;
  /** Option to align display value */
  position?: "left" | "right" | "center";
  /** Title of header */
  title?: string;
  /** Maxlength of title to display */
  maxLength?: number;
  /** Boolean to check if column is sorting */
  isSorter?: boolean;

}

function LayoutHeader(props: LayoutHeaderProps) {
  const {
    className,
    title,
    maxLength,
    position = "left",
  } = props;

  return (
    <button
      className={classNames(
        className,
        `layout-header__container`
      )}
    >
      <div
        className={classNames(
          "layout-header__title",
          `layout-header__title--${position}`
        )}
      >
        {maxLength && title?.length > maxLength ? (
          <Tooltip title={title}>
            {CommonService.limitWord(title, maxLength)}
          </Tooltip>
        ) : (
          title
        )}
      </div>
    </button>
  );
}
export default LayoutHeader;
